module.exports = __webpack_public_path__ + "static/media/aditya_logo.c5c4d3bc.png";